import { lens } from '@owl-nest/config'

type Global = {
  UFE: {
    assets: {
      defaultProjectPicture: string
    }
    urls: {
      widget: string
    }
  }
}

const windowLens = lens<Global>()

export const DEFAULT_PROJECT_IMAGE = windowLens
  .get('UFE')
  .get('assets')
  .get('defaultProjectPicture')
  .value(globalThis, { forgive: true, silent: true, trust: true })

export const WIDGET_URL = windowLens
  .get('UFE')
  .get('urls')
  .get('widget')
  .value(globalThis, { forgive: true, silent: true })
